export default {
  label: "Tickets",
  url:
    "https://secure.touchnet.net/C20832_ustores/web/store_main.jsp?STOREID=50&SINGLESTORE=true",
}
